module.exports = "data:image/gif;base64,R0lGODlhBQAFAJEAAAAAAP///8eMgv///yH/C05FVFNDQVBFMi4wAwEAAAAh+QQFAAADACwAAAAABQAFAAACB5xup8spUwAAOw=="